import React, { Component, Fragment } from 'react'
import {  Link, withRouter, NavLink, Redirect} from 'react-router-dom';
import { Button, Container, Menu, Responsive, Segment, Visibility, Icon } from 'semantic-ui-react'
import firebase from 'firebase'
// import Data from '../../router/Data'

import {Consumer, MyContext} from '../../../context/Context'

class Header_Main extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

   

    componentDidMount(){
        // console.log(this.props)
        document.addEventListener('mousedown', this.handleClick, false)
        // Data.handleAnimationChange()
    }

    // simulateClick(e) {
    //     // e.click()
    //   }

    //     handleClick=(e)=>{
    //         // e.preventDefault();

    //         if(e){
    //             e.preventDefault()
    //             // e.click()
    //             // console.log(' this.props.onClick(e);') || e.onClick();
    //             console.log(e)
    //         // e.click()
            
    //         // this.handleClose()
    //         return(
    //             // <Modal onClick={this.handleClose}>

    //             // </Modal>
    //            <Redirect to="/" /> 

    //         )
    //         }
    //         else{
    //         console.log('outside if')
    //         return
    //         }
    //         // this.handleClickOutside()
    //     }

    // handleAnimationChange = (animation) => () =>
    // setState((prevState) => ({ animation, visible: !prevState.visible }), handleDirectionChangeTrue('left'))

     ButtonMultipleConditionals = () => (
        <Button   basic  size ='huge'       onClick={this.props.action} inverted   fluid
         style={{ padding: '0px',  height: '80%' ,  width: '27vw', minWidth: "10vw", maxWidth: "30vw",
         marginRight:'27vw', 
      
        //  minHeight: '5.5vh',
         color:'white', background: 'black', border: "1px solid transparent", boxShadow: "white", 
        }}> 
         <Icon name='sidebar' />
          menu
          {/* <Fragment name='menu_sidebar' className='menu_sidebar'> Menu</Fragment>  */}
        
          </Button>
  
    )


    
    onLogoutHandler = dispatch => {
        localStorage.removeItem('token');
        localStorage.removeItem('expDate');
        localStorage.removeItem('userId');
        dispatch({ type: 'AUTH_LOGOUT', payload: { token: null, localId: null } });
        firebase.auth().signOut();
        this.props.history.push('/login');
        this.props.action(true)
    };

    handleItemClick = (e, { name }) => this.setState({ activeItem: name })

    hideFixedMenu = () => this.setState({ fixed: false })
    showFixedMenu = () => this.setState({ fixed: true })
    render() {
        // const { children } = this.props
        const { fixed } = this.state
        const { activeItem } = this.state
        return (
            <div className="nav-container">
            <Fragment>
                <Responsive>
                    <Consumer>
                        {value => {

                            const { dispatch } = value;
                            return (
                                <Visibility once={false} onBottomPassed={this.showFixedMenu} onBottomPassedReverse={this.hideFixedMenu}
                                //  style={{margin:'justified'}}
                                 >
                                {/* <Segment inverted textAlign='center' style={{ minHeight: 100, margin:'auto'}} vertical> */}

                                <Segment inverted 
                                // textAlign='center' 
                                // style={{ minHeight: 0, 
                                //     margin:'auto', 
                                //     }} 
                                    // vertical
                                    >
                                  
                                    <Menu  fixed={fixed ? 'top' : null} inverted={!fixed} pointing={!fixed} secondary={!fixed}   
                                     style={menuStyle} >
                                           
                                           <Container  >

                                                <Menu.Item style={{marginBottom:'0em', marginRight: '10vw'}} >
                                                {/* <Menu.Item style={{ marginRight: '0.9em' }} > */}
                                
                                                    {/* <Image size='mini' src='https://react.semantic-ui.com/logo.png' style={{ marginRight: '1.5em', }} to="/" as={Link} />  */}
                                                    <Link to="/" 
                                                    //  ref={this.handleClick} onClick={this.handleClick}

                                                     onMouseDown={ this.handleClick }>
                                                          <h1>mlstudio.ai</h1></Link></Menu.Item>


                                                <Menu.Menu position="right" >

                                                    {this.context.auth.token !== null ? (
                                                        <Fragment>

                                                            {/* <Menu.Item name='Home' active={activeItem === 'Home'} onClick={this.handleItemClick} style={{ marginBottom: '.5em' }} to="/" as={Link}>
                                                                Home</Menu.Item> */}

                                                            {/* <Menu.Item name='Services' active={activeItem === 'Services'} onClick={this.handleItemClick} style={{ marginBottom: '.5em' }} to="/home" as={Link}>
                                                                Services</Menu.Item> */}

                                                            {/* <Menu.Item name='GetStarted' active={activeItem === 'GetStarted'} onClick={this.handleItemClick} style={{ marginBottom: '.5em' }} to="/cardlist/card/add"  as={Link}>
                                                                Get Started</Menu.Item> */}

                                                            {/* <Menu.Item name='Projects' active={activeItem === 'Projects'} onClick={this.handleItemClick}
                                                             style={{ marginBottom: '.5em' }} 
                                                             style={{ marginRight: '0.5em', marginTop: '.0em', marginBottom:'.8em' }} 
                                                            to="/cardlist" as={Link}>
                                                                Projects</Menu.Item> */}

                                                            {/* <Menu.Item name='Profile' active={activeItem === 'Profile'} onClick={this.handleItemClick} style={{ marginBottom: '.5em' }} to="/profile" as={Link}>
                                                                Profile</Menu.Item> */}
                                                            
                                                            {this.ButtonMultipleConditionals()}


                                                            {/* <Menu.Item onClick={() => this.onLogoutHandler(dispatch)} style={{padding:'0px'}}  >

                                                            <Button inverted={!fixed} name='Logout' 
                                                            
                                                            style={{ marginRight: '0.5em', marginTop: '.0em', marginBottom:'.7em', }} size="big"  

                                                            active={activeItem === 'Logout'} onClick={this.handleItemClick}  >Log out</Button> </Menu.Item> */}

                                                    
                                                        </Fragment>
                                                    ) : (
                                                            <React.Fragment>
                                                                {/* <Menu.Item name='Home' active={activeItem === 'Home'} onClick={this.handleItemClick} style={{ marginBottom: '.5em' }} to="/" as={Link}>
                                                                    Home</Menu.Item> */}


                                                                {/* <Menu.Item name='Services' active={activeItem === 'Services'} onClick={this.handleItemClick} style={{ marginBottom: '.5em' }} to="/home" as={Link}>
                                                                    Services</Menu.Item> */}


                                                                {/* <Menu.Item name='GetStarted' active={activeItem === 'GetStarted'} onClick={this.handleItemClick} style={{ marginBottom: '.5em' }} to="/cardlist/card/add" as={Link} >
                                                                    Get Started</Menu.Item> */}


                                                                <Menu.Item  style={{padding:'0px', marginLeft: '-2.5em'}}>
                                                                    <Button inverted={!fixed} primary={fixed} style={{ marginRight: '0.5em', marginTop: '.0em', marginBottom:'.7em' }} size="big" name='Register'
                                                                        active={activeItem === 'Register'} onClick={this.handleItemClick} to="/register" as={Link}> Register</Button>

                                                                    <Button size="large" inverted={!fixed} style={{ marginTop: '.0em', marginBottom:'.7em' }} name='Login'
                                                                        active={activeItem === 'Login'} onClick={this.handleItemClick} to="/login" as={Link} >Log in</Button> </Menu.Item>
                                                            </React.Fragment>
                                                        )}
                                                </Menu.Menu>
                                            </Container>
                                        </Menu>
                                    </Segment>
                                </Visibility>)
                        }}
                    </Consumer>
                </Responsive>
    
            </Fragment>
            </div>
        )
    }
}


const menuStyle =  {
    background: "transparent",
    border: "5px solid transparent",
    boxShadow: "none",
    padding: "0em 0em",
    margin: "justified",
    // background: '#ffffff',
    opacity: '0.92',
    transition:' all -0.5s ease',
    borderBottom: '2px solid rgba(200, 200, 200, 0.8)',

    }


    

    

export default withRouter(Header_Main)
// export default  Header_Main
Header_Main.contextType = MyContext;

// const sizes = ['mini', 'tiny', 'small', 'large', 'big', 'huge', 'massive']